import React from "react";

interface AnchoredModalProps {
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  onClose: () => void;
  maxWidthClassName?: string;
}

export const AnchoredModal: React.FC<AnchoredModalProps> = ({
  title,
  children,
  footer,
  onClose,
  maxWidthClassName = "max-w-md",
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50">
      <div className={`bg-white rounded-t-xl w-full ${maxWidthClassName} p-6 animate-slideUp max-h-[90vh] flex flex-col`}>
        <div className="flex items-start justify-between gap-4 mb-4">
          <h3 className="text-lg font-bold">{title}</h3>
          <button
            type="button"
            className="text-gray-500 hover:text-gray-800 text-xl leading-none"
            onClick={onClose}
            aria-label="Chiudi"
          >
            x
          </button>
        </div>
        <div className="overflow-y-auto">{children}</div>
        {footer ? <div className="flex justify-between space-x-2 mt-4">{footer}</div> : null}
      </div>
    </div>
  );
};
